import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PreviousSettingsState {
  textColor: string;
  textFont: string;
  shadowColor: string;
  enableshadowColor: boolean;
}

const initialState: PreviousSettingsState = {
  textColor: "#FFFFFF",
  textFont: "Arial",
  shadowColor: "#000000",
  enableshadowColor: false,
};

export const previousSettingsSlice = createSlice({
  name: "previousSettingsSlice",
  initialState,
  reducers: {
    setTextColor: (state, action: PayloadAction<string>) => {
      state.textColor = action.payload;
    },
    setTextFont: (state, action: PayloadAction<string>) => {
      state.textFont = action.payload;
    },
    setTextShadowColor: (state, action: PayloadAction<string>) => {
      state.shadowColor = action.payload;
    },
    setEnableTextShadowColor: (state, action: PayloadAction<boolean>) => {
      state.enableshadowColor = action.payload;
    },

  },
});

// Action creators are generated for each case reducer function
export const { setTextColor, setTextFont, setTextShadowColor, setEnableTextShadowColor } = previousSettingsSlice.actions;

export default previousSettingsSlice.reducer;
